<template>
	<div class="DisplayAccess">
		<div class="font-small mb-1">{{ $t('Please enter your output UID') }}</div>
		<div style="width: 280px;" class="ml-a mr-a mb-1">
			<input type="text" name="UID" class="form-control uppercase" style="height: 50px; font-size: 27px; text-align: center;" v-model="UIDCode" required>
		</div>
		<button
			:disabled="!UIDCode"
			type="submit"
			class="btn btn-submit btn-primary mt-3"
			:class="{ 'is-loading': isFetching }"
			@shortkey="fetch" v-shortkey="{up: ['enter']}">
			<span @click="fetch">{{ $t('Activate') }}</span>
		</button>
	</div>
</template>

<script>
import displaysApi from '@/api/displays';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'DisplayAccess',
	data() {
		return {
			UIDCode: '',
			isFetching: false,
		};
	},
	methods: {
		fetch() {
			this.isFetching = true;
			const callback = (response) => {
				const item = response.data;
				const rundownId = item && item.rundown && item.rundown.id ? item.rundown.id : '';
				const url = `displays/live/${item.slug}/${item.id}?rundown_id=${rundownId}`;
				// const route = this.$router.resolve({ path: url });
				this.$router.push(url).catch(() => {});
				// window.open(route.href, '_blank');
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				let message = '';
				if (e.message.includes('Cannot read property') || e.message.includes('Cannot read properties')) {
					message = 'Your output UID is not available';
				} else {
					message = getAxiosErrorMessage(e);
				}
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Outputs',
					text: message || 'Display not available',
				});
				this.isFetching = false;
			};
			displaysApi.getByUID(this.UIDCode, callback, errorCallback);
		},
	},
	components: {
	},
	computed: {
	},
};
</script>
